import { API, PlanType } from '../types/enums';
import { axiosInstance } from './axios';

import {
  User,
  Dashboard,
  Website,
  WebsiteSettings,
  WebsiteStatus,
  PlanInfo,
  SuggestedWebsite,
  DashboardPayload
} from '../types/types';

export const fetchRegister = (email: string, password: string, name: string) =>
  axiosInstance.post<{ accessToken: string; user: User }>(API.REGISTER, {
    email,
    password,
    name
  });

export const fetchLogin = (email: string, password: string, secToken: string) =>
  axiosInstance.post<{ accessToken: string; user: User }>(API.LOGIN, {
    email,
    password,
    secToken
  });

export const fetchFreshToken = () => axiosInstance.get(API.REFRESH_TOKEN);

export const fetchLoginByToken = (token: string) =>
  axiosInstance.post<{ accessToken: string; user: User }>(API.LOGIN_WITH_TOKEN, {
    token
  });

export const updateName = (name: string) =>
  axiosInstance.patch<{ user: User }>(API.NAME_UPDATE, { name });

export const updateEnableAlerting = (isEnabled: boolean) =>
  axiosInstance.patch<{ user: User }>(API.ALERTING_ENABLED_UPDATE, { isEnabled });

export const updatePassword = (password: string, oldPassword: string) =>
  axiosInstance.patch<{ user: User }>(API.PASSWORD_UPDATE, {
    password,
    oldPassword
  });

export const logout = () => axiosInstance.get(API.LOGOUT);

export const createDashboard = (data: DashboardPayload) =>
  axiosInstance.post<Dashboard>(API.DASHBOARD_CREATE, data);

export const fetchDashboards = () => axiosInstance.get<{ dashboards: Dashboard[] }>(API.DASHBOARDS);

export const fetchDashboardDetails = (id: string) =>
  axiosInstance.get<Dashboard>(`${API.DASHBOARD_DETAILS}/${id}`);

export const updateDashboard = (id: string, data: DashboardPayload) =>
  axiosInstance.patch<Dashboard>(`${API.DASHBOARD_UPDATE}/${id}`, data);

export const deleteDashboard = (id: string) =>
  axiosInstance.delete<Dashboard>(`${API.DASHBOARD_DELETE}/${id}`);

export const sendDashboardByEmails = (id: string, emails: string[]) =>
  axiosInstance.post<Dashboard>(`${API.DASHBOARD_SEND}/${id}/send`, { emails });

export const fetchWebsites = () => axiosInstance.get<{ websites: Website[] }>(API.WEBSITES);

export const createWebsite = (payload: WebsiteSettings) =>
  axiosInstance.post<Website>(API.WEBSITE_CREATE, payload);

export const fetchStaticData = (path: string): Promise<WebsiteStatus> =>
  fetch(
    process.env.REACT_APP_STATUS_JSON_BASE_URL + path + '/status.json?v=' + new Date().valueOf()
  ).then((res) => res.json());

export const fetchDashboardSourcePath = (id: string) =>
  axiosInstance.get<{ path: string }>(`${API.SOURCE_PATH}/${id}`);

export const fetchWebsiteDetails = (id: string) =>
  axiosInstance.get<Website>(`${API.WEBSITE_DETAILS}/${id}`);

export const updateWebsite = (id: string, payload: WebsiteSettings) =>
  axiosInstance.patch<Website>(`${API.WEBSITE_UPDATE}/${id}`, payload);

export const deleteWebsite = (id: string) =>
  axiosInstance.delete<Website>(`${API.WEBSITE_DELETE}/${id}`);

export const saveSetup = (websites: { name: string; url: string }[]) =>
  axiosInstance.post(API.SETUP_SAVE, { websites });

export const fetchSuggestedWebsites = () => axiosInstance.get<SuggestedWebsite[]>(API.SETUP_SAVE);

export const sendForgotPAsswordEmail = (email: string) =>
  axiosInstance.post(API.SEND_FORGOT_PASSWORD_EMAIL, { email });

export const resetPassword = (password: string, passwordResetToken: string) =>
  axiosInstance.post(API.PASSWORD_RESET, {
    password,
    password_confirmation: password,
    passwordResetToken
  });

export const fetchUsers = () => axiosInstance.get<{ users: User[] }>(API.USERS);

export const fetchUser = (userId: string) =>
  axiosInstance.get<{ user: User }>(`${API.USER}/${userId}`);

export const updateUser = (user: User) =>
  axiosInstance.patch<User>(`${API.USERS}/${user.id}`, { ...user });

export const fetchPlanInfo = () => axiosInstance.get<PlanInfo>(API.PLAN_INFO);

export const fetchStripeUrl = (planType: PlanType) =>
  axiosInstance.post<{ url: string }>(API.CHECKOUT, { planType });

export const switchPlan = (planType: PlanType) =>
  axiosInstance.post<{ url: string }>(API.SWITCH_PLAN, { planType });

export const sendMessage = (message: string, email: string, name: string) =>
  axiosInstance.post(API.CONTACT, { message, email, name });
